<template>
  <Head title="Register" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-xl">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="register">
        <div class="px-10 py-8">
          <h1 class="text-center text-3xl font-bold">Please Register!</h1>
          <hr class="my-4" />
          <h3 class="text-center text-lg font-bold mb-4">
            Please be patient, there are a lot of inputs after this form, thank you for your patience.
          </h3>

          <h3 class="text-center text-lg mb-6">
            Because you are trying to register as an agent,<br />
            please don't use the same email address if you are trying to register for another account type.<br />
            You will be marked as pre agent, until you've submitted more details, and our HR will review the details.
          </h3>            
          <div class="mx-auto w-32 border-b-2 mb-8" />
          <div class="grid grid-cols-2 gap-4 mb-8">
            <text-input v-model="form.first_name" :error="form.errors.first_name" label="First name" />
            <text-input v-model="form.last_name" :error="form.errors.last_name" label="Last name" />
          </div>
          <text-input v-model="form.email" :error="form.errors.email" class="mb-4" label="Email" />
          <text-input v-model="form.password" :error="form.errors.password" class="mb-4" type="password" autocomplete="new-password" label="Password" />
          <text-input v-model="form.verify_password" :error="form.errors.verify_password" class="mb-4" type="password" autocomplete="new-password" label="Verify Password" />
          <file-input v-model="form.photo" :error="form.errors.photo" class="mb-4" type="file" accept="image/*" label="Photo" />
        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Register as Agent</loading-button>
        </div>
      </form>
      <div class="mt-4 text-center text-white">
        <Link :href="'#'" class="hover:underline">FAQ</Link> | 
        <Link :href="'#'" class="hover:underline">About Us</Link>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head, Link, 
    LoadingButton, Logo, FileInput, TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        verify_password: '',
        photo: null,
      }),
    }
  },
  methods: {
    register() {
      if (this.form.password !== this.form.verify_password) {
        // If passwords don't match, display an error and prevent form submission
        this.form.errors.verify_password = 'Passwords do not match, please recheck both passwords'
        return
      }
      // If passwords match, proceed with form submission
      this.form.post('/register_agent')
    },
  },
}
</script>
